import { Controller } from 'stimulus'
import { cart_pt_br_path } from "routes";
import { doPut } from "../../packs/utils";


export default class extends Controller {
  initialize() {}

  static get targets() {
    return ['select', 'loader'];
  }

  change(e) {
    let data = new FormData()
    data.append('item_uuid', this.selectTarget.getAttribute('data-item-uuid'))
    data.append('value', this.selectTarget.value)
    data.append('field', 'freight_type')

    this.loaderTarget?.classList.add('active')

    doPut(cart_pt_br_path(), data, (res) => {
      window.location.reload()
    })
  }

  // static targets = ["receiver", "provider"]
  //
  // perform() {
  //   console.log(this.receiverTarget)
  //   this.applyValue()
  //   this.receiverTarget.setAttribute('readonly', true)
  // }
  //
  // applyValue() {
  //   this.receiverTarget.setAttribute("value", this.providerTarget.selectedOptions.item(0).text)
  //   this.receiverTarget.value = this.providerTarget.selectedOptions.item(0).text
  // }
}
